import { render, staticRenderFns } from "./ModalEndosso.vue?vue&type=template&id=684726e2&scoped=true"
import script from "./ModalEndosso.vue?vue&type=script&lang=js"
export * from "./ModalEndosso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684726e2",
  null
  
)

export default component.exports